export { default } from "./ClaimStudentDiscountModal";
export {
  CLAIM_STUDENT_DISCOUNT_MODAL_ID,
  type ClaimStudentDiscountModalProps,
} from "./ClaimStudentDiscountModal";
